export default __webpack_public_path__ + "static/media/Gloves of the Hell Walker.d8f8d8aa.jpg";